module.exports = __webpack_public_path__ + "static/media/ci.f7d68310.jpg";